export const trackViewFreemiumTrainerEvent = () => {
  const localStorageKey = `freemiumTrainerViewed.${window.currentUser.id}`;
  const currentDay = new Date().getDate();
  const freemiumTrainerViewedDay = Number(
    localStorage.getItem(localStorageKey)
  );

  if (currentDay === freemiumTrainerViewedDay) {
    return;
  }

  localStorage.setItem(localStorageKey, currentDay);
};
